export const addLiveRampSegmentAttribution = (url: string, liveRampId: string) => `${url}&ads.eids=${liveRampId}`;
